import React from 'react'
import { Card, CardContent, Typography, styled } from '@mui/material';


const DemoCardContainer = styled(Card)`
  background-color: #f5f5f5;
  margin: 1rem 0;
  padding: 1rem;
`;

const ConfirmedText = styled(Typography)`
  color: green;
`;

const NotConfirmedText = styled(Typography)`
  color: red;
`;


function StudentDemoCard({ demos }) {
    

    if (demos.length === 0) {
        return (
          <DemoCardContainer>
            <CardContent>
              <Typography variant="h5" component="div">
                No Upcoming Demos
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Schedule a demo for this student.
              </Typography>
            </CardContent>
          </DemoCardContainer>
        );
      }
  return (
    <div>
        {demos.map((demo, index) => (
        <DemoCardContainer key={index}>
          <CardContent>
            <Typography variant="h5" component="div">
              Demo {index + 1} Details
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Class Details: {demo.classDetails}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Student Name: {demo.studentName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Student Email: {demo.studentEmail}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Demo Date: {demo.demoDate}
            </Typography>
            {demo.isConfirmed ? (
              <ConfirmedText variant="body2" color="primary">
                Demo Confirmed
              </ConfirmedText>
            ) : (
              <NotConfirmedText variant="body2" color="error">
                Demo Not Confirmed
              </NotConfirmedText>
            )}
            {demo.isConfirmed && (
              <>
                <Typography variant="body2" color="text.secondary">
                  Class Code: {demo.classCode}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Instructor Name: {demo.instructorName}
                </Typography>
              </>
            )}
          </CardContent>
        </DemoCardContainer>
      ))}
    </div>
  )
}

export default StudentDemoCard